import React from "react";
import Portfolio from "../components/Portfolio";

const PortfolioPage: React.FC = () => <Portfolio />;

export default PortfolioPage;
